<template>
  <div class="clear" style="width:100%">
    <div class="ca">
      <p class="qdTitle">CA解密</p>
      <div class="errorMsg">
        <p>{{ errorMsg }}</p>
      </div>
      <div class="ca-jm-dom">
        <div ref="ca_jm_dom"></div>
      </div>
      <div style="text-align:center">
        <el-button
          type="primary"
          :disabled="waitLoading"
          @click="checkCAUserForm()"
          >解密</el-button
        >
        <el-button @click="bj" type="primary" v-if="jm" :disabled="waitLoading"
          >上传补救文件</el-button
        >
        <el-button
          @click="sqbj"
          type="primary"
          v-if="!jm"
          :disabled="waitLoading"
          >申请补救</el-button
        >
      </div>
    </div>
     <!-- <div class="ewm">
      <div>
        <p class="qdTitle">二维码解密</p>
        <img
          :src="ewmUrl"
          alt=""
          style="width:243px;height:243px;margin-bottom:10px;"
          @click="getJmEwm()"
          v-if="sfApp"
        />
        <img
          src="../assets/images/sfApp.png"
          alt=""
          style="width:243px;height:243px;margin-bottom:10px;"
          v-else
        />
        <p>请用手机证书APP扫描二维码</p>
      </div>
    </div>  -->
    <object
      id="USBKeyApi"
      classid="clsid:1246FA8B-41FD-4B45-90B8-47ED9772A1CD"
      style="position: absolute;top:-5000px"
    >
      <embed name="USBKeyApi" type="application/npSOFSignApi-plugin" />
    </object>
    <!-- 弹窗 -->
    <el-dialog :append-to-body="true" :visible.sync="visible" width="1100px" title="解密" v-if='visible' :close-on-click-modal="false" :show-close="progressData.decryptStatus !== 0 " @close="closeDialog" >
      <div class="progress-layout">
        <div class="progress-text">
          {{ progressData.decryptStatus === 0 ? '投标文件解密中，请耐心等待' : progressData.decryptStatus === 1 ? '解密成功' : '解密失败,请重新尝试' }}
        </div>
        <div class="progress-box">
          <el-progress class="progress-item" :text-inside="true" :stroke-width="40" :percentage="percentage" :status="progressData.decryptStatus === 2 ? 'exception' : 'success'"></el-progress>
        </div>
        <div class="progress-btn" v-if="progressData.decryptStatus !== 0">
          <el-button  type="danger" @click="closeDialog">确定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import setting  from "@/settings"
export default {
  name: "jmCom",
  props: ["jm", "list", "sfApp"],
  data() {
    return {
      errorMsg: "",
      ewmUrl: "",
      visible: false,
      parentJm:'',
      progressData:{
        decryptStatus:0,
        total:0,
        lastCount:0
      },
      obj: {},
      progressInterval:null,
      getObj:{}, // 用于临时存储解密进度条的传参
      jmewmDsq: null, //tbr验证是否扫码定时器
      getTime: null, //获取二维码的定时器2分钟一次
      role: localStorage.getItem("role") ? localStorage.getItem("role") : "T",
      waitLoading: false,
      lock_: null,
      config: {
        select: {
          style: {
            width: "380px",
            backgroundSize: "17px 14px",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "8px center",
          },
          placeholder: "请选择CA证书",
          userCheckRequest: setting.stystemLx,
          userCheckUrl:setting.caCheckUrl
        },
        detection: {
          name: "检 测",
        },
        pin: {
          style: {
            width: "480px",
            backgroundSize: "13px 21px",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "8px center",
          },
          maxLength: 16,
          placeholder: "请输入CA密码",
        },
        style: "loginOne",
        certInfoCode: [
          "NOTBEFORE",
          "AFTER",
          "ORGANIZATIONCODE",
          "SUBJECT_O",
          "PUBKEY",
        ], // 证书信息 不传默认返回锁的名字,证书序列号,锁的类型
        callback: (res) => {
          if (res.state == "succeed") {
            if (res.type == "login") {
              var jm = "";
              var jgdm = res.data.currentUser.ORGANIZATIONCODE
              this.list.forEach((e) => {
                if (e.fcqyjgdm == jgdm) {
                  jm = e.jmmw;
                }
              });
              var jmmw;
              if (jm) {
                if(res.data.currentUser.type == 'B'){
                  jmmw = this.lock_.USBKeyApi.PriKeyDecrypt(res.data.currentUser.code, jm);
                } else if (res.data.currentUser.type == 'A'){
                  jmmw = this.lock_.cwcaClient.SOF_DecryptData(res.data.currentUser.certOptID, jm);
                }else if (res.data.currentUser.type == 'E'){
                  //安徽ca解密，密码和密文，
                  var psd=document.getElementById('pinInput_lock').value;
                  //jmmw = this.lock_.ahCert.certDec(psd, jm);
                  jmmw=''
                }
              } else {
                jmmw = "";
              }
              this.obj = {
                jgdm: jgdm,
                jmmw: jmmw,
                caNo:res.data.currentUser.code
              };
              // this.$emit("Qd", this.obj);
              this.errorMsg = "";
            }
          }
        },
        callMessage: {},
      },
    };
  },
  methods: {
    async tbdwJmDetail(obj){
      let params = {
        jgdm:obj.jgdm,
        jmmw:obj.jmmw,
        sftbr:this.role === 'B',
        caNo:obj.caNo
      }
      this.getObj = obj
      this.$api.tbdwJmDetail(params).then(res=>{
        this.progressData = res.data.data
        this.progressData.decryptStatus = Number(this.progressData.decryptStatus)
        if(this.progressData.decryptStatus == 1){
          clearInterval(this.progressInterval);
          clearInterval(this.intervalTbjm);
          this.intervalTbjm=null;
          this.progressInterval=null
          let obj={
            lx:'tb',
            data:{
              index:2,
              msg:'2',
              all:true
            }
          }
          this.$emit('refreshJmzt');
        }
      })
    },
    //保存解密成功
    saveJm(obj){
      // 重置解密进度信息
      this.progressData = {
        decryptStatus:0,
        total:0,
        lastCount:0
      }
      let para={
        jgdm:obj.jgdm,
        jmmw:obj.jmmw,
        sftbr: this.role === 'B',
        caNo:obj.caNo
      }
      this.$api.checkJm(para).then(res=>{
        if(res.data.meta.success){
          this.visible = true;
          this.progress = true
          this.tbdwJmDetail(obj)
          this.progressInterval = setInterval(() => {
            this.tbdwJmDetail(obj)
          }, 2000);
        }else{
          this.$message({
            type:'error',
            message:res.data.meta.message
          })
        }
        this.form.password='';
      }).catch(()=>{})
    },
    closeDialog(){
      this.visible = false;
      this.$emit('closeCaDialog');
      clearInterval(this.progressInterval)
      this.progressInterval = null
      if(this.progressData.decryptStatus === 2){ // 若失败则数据清空
        this.progressData = {
          decryptStatus:0,
          total:0,
          lastCount:0
        }
        this.progress = false,
        this.getObj = {}
      }
    },
    bj() {
      this.$emit("bj");
    },
    sqbj() {
      this.$emit("sqbj");
    },
    //获取二维码
    getJmEwm() {
      clearInterval(this.getTime);
      this.getTime = null;
      this.getTime = setInterval(() => {
        this.getJmEwm();
      }, 120000);
      if (this.role == "Z") {
        clearTimeout(this.jmewmDsq);
        this.jmewmDsq = null;
        this.$api
          .getJmEwm()
          .then((res) => {
            if (res.data.meta.success) {
              this.ewmUrl = "data:image/gif;base64," + res.data.data.picdata;
              this.uuid = res.data.data.uuid;
              this.setSrcJm();
            }
          })
          .catch(() => {});
      } else {
        clearTimeout(this.jmewmDsq);
        this.jmewmDsq = null;
        this.$api
          .getTbrJmEwm()
          .then((res) => {
            if (res.data.meta.success) {
              this.ewmUrl = "data:image/gif;base64," + res.data.data.picdata;
              this.uuid = res.data.data.uuid;
              this.setSrcJm();
            }
          })
          .catch(() => {});
      }
    },
    //验证扫描二维码是否成功
    setSrcJm() {
      let para = {
        uuid: this.uuid,
      };
      clearTimeout(this.jmewmDsq);
      this.jmewmDsq = null;
      this.jmewmDsq = setTimeout(() => {
        this.setSrcJm();
      }, 2000);
      if (this.role == "Z") {
        let _this = this;
        this.$api
          .setJmSrc(para)
          .then((res) => {
            //扫码成功后
            if (res.data.data != null && res.data.data != "") {
              clearInterval(_this.jmewmDsq);
              _this.jmewmDsq = null;
              let obj = {
                jgdm: res.data.data.jgdm,
                qymc: res.data.data.qymc,
              };
              this.$emit("ewmQd", obj);
            }
          })
          .catch(() => {});
      } else {
        let _this = this;
        this.$api
          .setTbrJmSrc(para)
          .then((res) => {
            //扫码成功后
            if (res.data.meta.success) {
              clearInterval(_this.jmewmDsq);
              _this.jmewmDsq = null;
              this.$emit("ewmQd");
            }
          })
          .catch(() => {});
      }
    },
    async checkCAUserForm() {
      try {
        this.lock_.checkPin(this.lock_.currentUser)
        await this.saveJm(this.obj);
      } catch (e) {
        console.error(e)
      }
    },
  },
  computed: {
    percentage(){
      return this.progressData.total !== -1 ? this.progressData.total === 0 ? 0: ((this.progressData.total - this.progressData.lastCount) / this.progressData.total).toFixed(2)*100 : 100
    },
  },
  mounted() {
    clearInterval(this.getTime);
    this.getTime = null;
    clearTimeout(this.jmewmDsq);
    this.jmewmDsq = null;
    if (this.sfApp) {
      this.getJmEwm();
    }
    if (this.$refs.ca_jm_dom) {
      this.lock_ = new lock();
      this.lock_.init(this.$refs.ca_jm_dom, this.config);
    }
  },
  beforeDestroy() {
    clearInterval(this.getTime);
    this.getTime = null;
    clearTimeout(this.jmewmDsq);
    this.jmewmDsq = null;
  },
};
</script>
<style lang="less" scoped>
div.ca {
  width: 60%;
  padding: 0 80px 0 50px;
  float: left;
  height: 350px;
  .el-select {
    width: calc(~"100% - 110px");
    margin-right: 10px;
  }
}

div.ewm {
  > div {
    width: 250px;
    text-align: center;
    margin: 0 auto;
    p.qdTitle {
      text-align: left;
    }
  }
  width: 40%;
  float: left;
  position: relative;
  img {
    display: block;
    background: #fff;
  }
}
div.ewm:before {
  content: "";
  border-left: 1px solid #ddd;
  height: 320px;
  position: absolute;
  top: 0;
  left: 0;
}
p {
  color: #666;
  font-size: 16px;
}
p.qdTitle {
  color: #333;
  font-size: 18px;
  margin-bottom: 20px;
}
.allWidth {
  div.ca {
    width: 630px;
    text-align: center;
  }
  div.ewm {
    width: 500px;
  }
}
.ca-jm-dom {
  display: flex;
  justify-content: center;
}
.progress{
  &-layout{
    height: 260px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  &-text{
    text-align: center;
    font-size: 18px;
    margin-bottom: 40px;
  }
  &-item{
    width: 80%;
    margin: 0 auto;
  }
  &-btn{
    width: 100%;
    margin-top: 50px;
    display: flex;
    justify-content: center;
  }
  &-box{
    position: relative;
    .el-icon-circle-close{
      position: absolute;
      font-size: 40px;
      color:rgb(255,0,0);
      top:0;
      right: 40px;
    }
  }
}
</style>
